import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Header from '../Header';
import baseUrl from '../BaseUrl';
import Loader from '../Loader';

const ENRMSRegistrationIndex = () => {
    const [name,   setName]   = useState('');
    const [token,  setToken]  = useState('');
    const [expire, setExpire] = useState('');
    const [role,   setRole]   = useState('');
    const [access, setAccess] = useState([]);
    const [user,   setUser]   = useState(null);
    const navigate = useNavigate();

    useEffect(() => { refreshToken(); getUserAccess(); }, []);
    useEffect(() => { if (role > 2) navigate('/dashboard'); }, [role]);
    useEffect(() => {
        if (user !== null && role > 1 && !user.enrms_registration_switch) {
            navigate('/dashboard');
        }
    }, [user, role]);

    const refreshToken = async () => {
        try {
            const res = await axios.get(`${baseUrl}/token`);
            setToken(res.data.accessToken);
            const decoded = jwt_decode(res.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role);
            setExpire(decoded.exp);
        } catch {
            navigate('/');
            window.location.reload();
        }
    };

    const getUserAccess = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAccess(res.data.results);
            setUser({
                enrms_registration_switch:       res.data.enrms_registration_switch       || 0,
                enrms_registration_edit_switch:  res.data.enrms_registration_edit_switch  || 0,
                enrms_registration_admin_switch: res.data.enrms_registration_admin_switch || 0
            });
        } catch (e) { console.log(e); }
    };

    const axiosJWT = axios.create();
    axiosJWT.interceptors.request.use(async (config) => {
        if (expire * 1000 < Date.now()) {
            const res = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${res.data.accessToken}`;
            setToken(res.data.accessToken);
            const decoded = jwt_decode(res.data.accessToken);
            setName(decoded.name);
            setExpire(decoded.exp);
        }
        return config;
    }, err => Promise.reject(err));

    const isSuperAdmin = role !== '' && role <= 1;
    const hasAdmin = isSuperAdmin || user?.enrms_registration_admin_switch === 1;
    const hasEdit  = isSuperAdmin || user?.enrms_registration_edit_switch  === 1;
    const hasBase  = isSuperAdmin || user?.enrms_registration_switch       === 1;

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {user === null && <Loader />}
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title"><h1>E-NRMS Registration</h1></div>
                        </div>
                        <div className="col-6 inventory-btn">
                            <div className="addnew-button">
                                <Link to="/enrms-management"><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row numberboxes">
                        {hasAdmin && (
                            <div className="col-md-3">
                                <Link to="/enrms-registration-admin">
                                    <div className="dashboard-box" id="bbdbox">
                                        <div className="imagebox">
                                            <img src={`${process.env.PUBLIC_URL}/images/bxs-phone.png`} alt="" />
                                        </div>
                                        <h3>Admin Setup</h3>
                                        <p>Websites, Risk Types, Emails</p>
                                    </div>
                                </Link>
                            </div>
                        )}
                        {(hasEdit || hasBase) && (
                            <div className="col-md-3">
                                <Link to="/enrms-registration-setup">
                                    <div className="dashboard-box" id="number">
                                        <div className="imagebox">
                                            <img src={`${process.env.PUBLIC_URL}/images/bxs-phone.png`} alt="" />
                                        </div>
                                        <h3>Registration Setup</h3>
                                        <p>Language, Details, TN Management &amp; Export</p>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ENRMSRegistrationIndex;
